<template>
    <div>
        <section>

            <b-button v-for="(value) in pjList" :key="value.slug"
                      :style="{ color: value.color }" :icon-left="value.icone"  @click="editElement(value.slug)">
                {{value.nom}}
            </b-button>

        </section>

        <h2 class="decale"><button class="button is-info is-small"
                    @click="createElement('PNJ')">
            <b-icon  icon="plus"></b-icon>
        </button> PNJ </h2>
        <section>

            <b-tooltip  v-for="(value) in pnjList" :key="value.slug"
                        :label="value.nom"
                       position="is-right">
                <b-button :style="{ color: value.color }"
                          :icon-left="value.icone"  @click="editElement(value.slug)">
                </b-button>
            </b-tooltip>


        </section>
        <h2 class="decale"><button class="button is-info is-small"
                         @click="createElement('OBJ')">
            <b-icon  icon="plus"></b-icon>
        </button> OBJETS  </h2>
        <section>
            <b-tooltip  v-for="(value) in objList" :key="value.slug"
                        :label="value.nom"
                        position="is-right">
                <b-button :style="{ color: value.color }"
                          :icon-left="value.icone"  @click="editElement(value.slug)">
                </b-button>
            </b-tooltip>
        </section>
        <h2 class="decale"><button class="button is-info is-small"
                    @click="createElement('BAD')">
            <b-icon  icon="plus"></b-icon>
        </button> MONSTRES   </h2>
        <section>
            <b-tooltip  v-for="(value) in badList" :key="value.slug"
                        :label="value.nom"
                        position="is-right">
                <b-button :style="{ color: value.color }"
                          :icon-left="value.icone"  @click="editElement(value.slug)">
                </b-button>
            </b-tooltip>
        </section>

        <h2 class="decale"><button class="button is-info is-small"
                    @click="createElement('DEC')">
            <b-icon  icon="plus"></b-icon>
        </button> DECOR</h2>
        <section>
            <b-tooltip  v-for="(value) in decList" :key="value.slug"
                        :label="value.nom"
                        position="is-right">
                <b-button :style="{ color: value.color }"
                          :icon-left="value.icone"  @click="editElement(value.slug)">
                </b-button>
            </b-tooltip>
        </section>

        <b-modal :active.sync="isComponentModalActive"has-modal-card  scroll="keep" @cancel="cancel">
            <scene-element :config="config" :key="getKey" @cloneMe="createElementByClone"></scene-element>
        </b-modal>
    </div>
</template>

<script>
    import sceneelement from './Element.vue'
    import ElementClass from '../classes/Element'

    export default {
        name: 'gauche',
        data (){
            return {
                isComponentModalActive: false,
                config: '',
            }
        },
        components: {
            'scene-element' : sceneelement,
        },
        props: ['type'],
        computed: {
            pjList(){
                return this.$store.getters.getElementType('JOUEUR')
            },
            pnjList(){
                return this.$store.getters.getElementType('PNJ')
            },
            objList(){
                return this.$store.getters.getElementType('OBJ')
            },
            badList(){
                return this.$store.getters.getElementType('BAD')
            },
            decList(){
                return this.$store.getters.getElementType('DEC')
            },

            //Astuce sur la Kep de la modal pour gerer les re-render
            getKey(){
                return this.config.id ? this.config.id : ''
            }
        },
        methods: {
            createElement(type){
                this.config=new ElementClass(type)
                this.isComponentModalActive = true
            },
            createElementByClone(evt){
                this.isComponentModalActive = false

                this.config=new ElementClass(evt.type)
                this.config.caracBuffer=evt.carac
                this.config.icone=evt.icone
                this.config.color=evt.color
                this.config.cloneOf=evt.slug
                this.config.nom=""
                this.isComponentModalActive = true
            },
            async editElement(slug){
                // Ramene à partir de la base !! C'est la vérité
                const res=await this.$mydb.do.getElement(slug)
                this.config=res[0]

                //open la modale
                this.isComponentModalActive = true
            },
            cancel(){

            }
        },
        mounted(){
            this.$store.dispatch('updateElement')
        }
    }

</script>


<style lang="scss">

    .decale{
        margin-top:5px !important;
    }

</style>